import React from 'react'
import Main from './Main';
import BuyBox from './Buybox';

import './styles/Homepage.css'

export default function Homepage() {
  
  return (
    <>
      <BuyBox/>
      <Main/>
    </>
  )
}

